import { render } from "./PriceManage.vue?vue&type=template&id=18b14eef&scoped=true"
import script from "./PriceManage.vue?vue&type=script&lang=js"
export * from "./PriceManage.vue?vue&type=script&lang=js"

import "./PriceManage.vue?vue&type=style&index=0&id=18b14eef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b14eef"]])

export default __exports__